<!-- #737 Tab „Nachrichten": Filterzeile -> Kopfzeile -> Zeilen -> Mehr laden. Titelzeile und
     Brotkrume haelt der Container. -->
<div>

  <div class="flex flex-col lg:flex-row px-[0.75rem] py-[0.4rem] leading-[1rem] bg-white gap-2">
    <div class="flex flex-row flex-wrap gap-2 lg:flex-1">

      <!-- Empfaenger: der wichtigste Filter. Nimmt serverseitig eine UUID — ein Support-Mitarbeiter
           kennt aber einen Namen, deshalb Auswahl mit Suche statt UUID-Textfeld. -->
      <nx-filter-dropdown
        [className]="'table-filter'"
        [filter]="true"
        [filterBy]="'displayName'"
        [appendTo]="'body'"
        [showClear]="true"
        [ngModel]="recipientUserId()"
        [options]="usersValue()"
        [optionValue]="'id'"
        optionLabel="displayName"
        [placeholder]="'core.notificationDiagnostics.filters.recipient' | translate"
        (onChange)="onRecipientChange($any($event).value)"
        (onClear)="onRecipientChange(null)">
      </nx-filter-dropdown>

      <!-- Typ: label kommt fertig uebersetzt vom Server, deshalb KEIN arrayTranslate. -->
      <nx-filter-dropdown
        [className]="'table-filter'"
        [filter]="true"
        [filterBy]="'label'"
        [appendTo]="'body'"
        [showClear]="true"
        [ngModel]="typeKey()"
        [options]="typeOptionsValue()"
        [optionValue]="'value'"
        optionLabel="label"
        [placeholder]="'core.notificationDiagnostics.filters.type' | translate"
        (onChange)="onTypeKeyChange($any($event).value)"
        (onClear)="onTypeKeyChange(null)">
      </nx-filter-dropdown>

      <!-- Zeitraum: liefert bereits ISO-8601-Instants mit Z (toISOString). Gefiltert wird auf
           createdAt. -->
      <nx-filter-date-select
        [className]="'table-filter'"
        [placeholder]="'core.notificationDiagnostics.filters.period' | translate"
        [showIncludeOverDue]="false"
        [ngModel]="dateRange()"
        (onChange)="onDateRangeChange($any($event))"
        (onClear)="onDateRangeChange(null)"
        optionLabel="label">
      </nx-filter-date-select>

      <!-- KEIN Kanal- und KEIN Statusfilter: auf einer Nachricht hiesse „Status: FAILED" nur „bei
           irgendeinem Kanal ging etwas schief". Die gibt es im Zustell-Tab. -->
    </div>
  </div>

  <!-- Pruefreihenfolge ist verbindlich: error() VOR loading().
       border-t auf jedem Zustandsblock: die Linie trennt Filterzeile und Inhalt. Sobald Zeilen da
       sind, uebernimmt die Kopfzeile der Kanalspalten diese Aufgabe und traegt sie selbst. -->
  @if (error()) {
    <div class="bg-white px-5 py-4 text-[#c0123c] border-t border-gray">
      {{ 'core.notificationDiagnostics.messages.loadErrorMessage' | translate }}
    </div>
  } @else if (loading()) {
    <div class="bg-white px-5 py-4 flex flex-row justify-center border-t border-gray">
      <p-progressSpinner [style]="{ width: '2rem', height: '2rem' }" strokeWidth="4"></p-progressSpinner>
    </div>
  } @else if (items().length === 0) {
    <nx-empty-box
      class="border-t border-gray"
      [label]="'core.notificationDiagnostics.messages.emptyMessage'">
    </nx-empty-box>
  } @else {

    <!-- Kopfzeile: die Kanalnamen stehen EINMAL hier, damit die Zelle den Zustand tragen kann.
         channels kommt aus derselben Konstante wie die Zellen in notification-admin-row.component.ts
         (DELIVERY_CHANNEL_VALUES) — sonst laufen Kopfzeile und Spalten auseinander. Die Breite w-28
         shrink-0 muss mit notification-admin-row.component.html uebereinstimmen. -->
    <div class="flex flex-row items-center px-5 py-1 text-[14px] text-[#848488] bg-white border-t border-b border-gray">
      <div class="grow"></div>
      @for (channel of channels; track channel) {
        <div class="w-28 shrink-0 flex flex-row justify-center">{{ channelLabelKey(channel) | translate }}</div>
      }
    </div>

    @for (entry of items(); track entry.id) {
      <div
        notification-admin-row
        [entry]="entry"
        [recipientName]="recipientName(entry.recipientUserId)">
      </div>
    }

    <!-- Keine Seitenzahlen und KEINE Gesamtzahl: die API liefert bewusst kein totalCount. -->
    @if (hasMore()) {
      <nx-default-button
        class="block mt-2"
        [style]="'light'"
        [width]="'full'"
        [disabled]="loadingMore()"
        (click)="loadMore()"
        [label]="loadingMore() ? 'core.notificationDiagnostics.loadingMore' : 'core.notificationDiagnostics.loadMore'">
      </nx-default-button>
    }
  }
</div>
